import {AEntity} from "./abstract/AEntity";

export interface IAgence {
    dirLib: string
    domLib: string
    ageLib: string
    ageLibLong: string
    ageDesc: string
}

export class Agence extends AEntity {
    dirLib: string
    domLib: string
    ageLib: string
    ageLibLong: string
    ageDesc: string

    constructor(agence : IAgence) {
        super();
        this.dirLib = agence.dirLib;
        this.domLib = agence.domLib;
        this.ageLib = agence.ageLib;
        this.ageLibLong = agence.ageLibLong;
        this.ageDesc = agence.ageDesc;
    }

    override getId(): string {
        return `${this.dirLib}|${this.domLib}|${this.ageLib}`;
    }

    override toJSON(): IAgence {
        return {
            dirLib: this.dirLib,
            domLib: this.domLib,
            ageLib: this.ageLib,
            ageLibLong: this.ageLibLong,
            ageDesc: this.ageDesc,
        }
    }
}
